import { el, setOnScreen, showScreen } from './api';
import { enqueueEvents } from './anim';
import { setupBidPanel, setupHandClicks } from './render';
import { onApply } from './store';
import { watchVisibility } from './sse';
import { leaveGame } from './actions';
import {
  applyAdminUI,
  goToJoinScreen,
  goToSetupScreen,
  handleBugSubmit,
  handleCreateGame,
  handleJoin,
  handleLogout,
  loadOpenGames,
  loadOpenGamesMenu,
  loginFromSupabase,
  setupToggleListeners,
  showAdminPanel,
  showBugModal,
  showHistory,
  tryResumeGame,
} from './lobby';
import { playerId } from './store';

onApply((snap) => {
  enqueueEvents(snap.events ?? []);
});

setOnScreen((id) => {
  if (id === 'menu-screen') void loadOpenGamesMenu();
});

async function init(): Promise<void> {
  await loginFromSupabase();
  if ((window as any).__godbeyAuth) {
    (window as any).__godbeyAuth.onChange(() => { void loginFromSupabase(); });
  }
  watchVisibility();
  applyAdminUI();

  el('new-game-btn').addEventListener('click', goToSetupScreen);
  el('join-game-btn').addEventListener('click', goToJoinScreen);
  el('menu-refresh-open-btn').addEventListener('click', () => { void loadOpenGamesMenu(); });
  el('history-btn').addEventListener('click', () => { void showHistory(); });
  el('admin-btn').addEventListener('click', () => { void showAdminPanel(); });
  el('logout-btn').addEventListener('click', () => { void handleLogout(); });

  setupToggleListeners();
  el('create-game-btn').addEventListener('click', () => { void handleCreateGame(); });
  el('setup-back-btn').addEventListener('click', () => showScreen('menu-screen'));

  el('seat-picker-close').addEventListener('click', () => el('seat-picker-modal').classList.add('hidden'));
  el('seat-picker-modal').addEventListener('click', e => {
    if (e.target === el('seat-picker-modal')) el('seat-picker-modal').classList.add('hidden');
  });

  el('join-btn').addEventListener('click', () => { void handleJoin(); });
  el('join-back-btn').addEventListener('click', () => showScreen('menu-screen'));
  el<HTMLInputElement>('join-code-input').addEventListener('keydown', e => {
    if (e.key === 'Enter') void handleJoin();
  });

  el('history-close').addEventListener('click', () => el('history-modal').classList.add('hidden'));
  el('history-modal').addEventListener('click', e => {
    if (e.target === el('history-modal')) el('history-modal').classList.add('hidden');
  });

  el('admin-close').addEventListener('click', () => el('admin-modal').classList.add('hidden'));
  el('admin-modal').addEventListener('click', e => {
    if (e.target === el('admin-modal')) el('admin-modal').classList.add('hidden');
  });

  el('btn-bug-report').addEventListener('click', showBugModal);
  el('bug-close').addEventListener('click', () => el('bug-modal').classList.add('hidden'));
  el('bug-modal').addEventListener('click', e => {
    if (e.target === el('bug-modal')) el('bug-modal').classList.add('hidden');
  });
  el('bug-submit-btn').addEventListener('click', () => { void handleBugSubmit(); });
  el('refresh-open-btn').addEventListener('click', () => { void loadOpenGames(); });

  el('btn-history').addEventListener('click', () => { void showHistory(); });
  el('btn-menu').addEventListener('click', () => {
    if (confirm('Leave current game?')) {
      leaveGame();
      showScreen('menu-screen');
    }
  });

  el('copy-code-btn').addEventListener('click', () => {
    const code = el('join-code-value').textContent ?? '';
    navigator.clipboard.writeText(code).catch(() => { /* ignore */ });
    el('copy-code-btn').textContent = '✓ Copied!';
    setTimeout(() => { el('copy-code-btn').textContent = '📋 Copy'; }, 1500);
  });

  setupBidPanel();
  setupHandClicks();

  if (playerId) {
    const resumed = await tryResumeGame();
    if (!resumed) showScreen('menu-screen');
  } else {
    showScreen('login-screen');
  }
}

document.addEventListener('DOMContentLoaded', () => { void init(); });
